<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="TOC">Contents</h1>
<p class="toc1" style="margin-top:20px;"><a href="#/4chap1#chap1">Chapter I</a></p>
<p class="toc1"><a href="#/5chap2#chap2">Chapter II</a></p>
<p class="toc1"><a href="#/6chap3#chap3">Chapter III</a></p>
<p class="toc1"><a href="#/7chap4#chap4">Chapter IV</a></p>
<p class="toc1"><span href="#/8chap5#chap5" title="Link target outside of Sample">Chapter V</span></p>
<p class="toc1"><span href="#/9chap6#chap6" title="Link target outside of Sample">Chapter VI</span></p>
<p class="toc1"><span href="#/10chap7#chap7" title="Link target outside of Sample">Chapter VII</span></p>
<p class="toc1"><span href="#/11chap8#chap8" title="Link target outside of Sample">Chapter VIII</span></p>
<p class="toc1"><span href="#/12chap9#chap9" title="Link target outside of Sample">Chapter IX</span></p>
<p class="toc1"><span href="#/13chap10#chap10" title="Link target outside of Sample">Chapter X</span></p>
<p class="toc1"><span href="#/14chap11#chap11" title="Link target outside of Sample">Chapter XI</span></p>
<p class="toc1"><span href="#/15chap12#chap12" title="Link target outside of Sample">Chapter XII</span></p>
<p class="toc1"><span href="#/16chap13#chap13" title="Link target outside of Sample">Chapter XIII</span></p>
<p class="toc1"><span href="#/17chap14#chap14" title="Link target outside of Sample">Chapter XIV</span></p>
<p class="toc1"><span href="#/18chap15#chap15" title="Link target outside of Sample">Chapter XV</span></p>
<p class="toc1"><span href="#/19chap16#chap16" title="Link target outside of Sample">Chapter XVI</span></p>
<p class="toc1"><span href="#/20chap17#chap17" title="Link target outside of Sample">Chapter XVII</span></p>
<p class="toc1"><span href="#/21chap18#chap18" title="Link target outside of Sample">Chapter XVIII</span></p>
<p class="toc1"><span href="#/22chap19#chap19" title="Link target outside of Sample">Chapter XIX</span></p>
<p class="toc1"><span href="#/23chap20#chap20" title="Link target outside of Sample">Chapter XX</span></p>
<p class="toc1"><span href="#/24chap21#chap21" title="Link target outside of Sample">Chapter XXI</span></p>
<p class="toc1"><span href="#/25chap22#chap22" title="Link target outside of Sample">Chapter XXII</span></p>
<p class="toc1"><span href="#/26chap23#chap23" title="Link target outside of Sample">Chapter XXIII</span></p>
<p class="toc1"><span href="#/27chap24#chap24" title="Link target outside of Sample">Chapter XXIV</span></p>
<p class="toc1" style="margin-top:20px;"><span href="#/28chap25#chap25" title="Link target outside of Sample">Afterword</span></p>
<p class="toc1" style="margin-top:20px;"><span href="#/30biography#biography" title="Link target outside of Sample">A Biography of Mary Renault</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 3TOC.vue?4753fced